import { render, staticRenderFns } from "./PlanPartnerJoinRequest.vue?vue&type=template&id=571b1c73&scoped=true"
import script from "./PlanPartnerJoinRequest.vue?vue&type=script&lang=js"
export * from "./PlanPartnerJoinRequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "571b1c73",
  null
  
)

export default component.exports